/* eslint-disable no-unused-expressions */
/* eslint-disable react-hooks/exhaustive-deps */
// import { useEffect,useState } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route
} from "react-router-dom";
import MainPage from './pages/MainPage';
import './App.scss';

function App() {
  
  return (
    <div className="App">
       <Router>
          <Routes>
            {/* <Route path="/iam.timocom.com/*" element={<LoginPage/>} />
            <Route path="/realms/*" element={<LoginPage/>} />
            <Route path="/my.timocom.com/app/tcgate" element={<MyTimocom/>} /> */}
            <Route path="*" element={<MainPage />} />
          </Routes> 
      </Router>
    </div>
  );
}

export default App;
